// extracted by mini-css-extract-plugin
module.exports = {"vGutterX":"30px","tablet-up":"(min-width: calc(768 * 1px))","registration":"Registration_registration__2bXm_"};